import { Box, Button, ButtonPriority, TextButton } from '@wix/design-system'
import { ArrowLeft } from '@wix/wix-ui-icons-common'
import React, { FC, memo, MouseEventHandler } from 'react'
import { useMediaQuery } from 'react-responsive'

import { LARGE_DESKTOP } from '../../../breakpoints'

type BackButtonProps = {
  type?: 'TextButton' | 'Button'
  backButton?: string | null
  onClick?: MouseEventHandler<HTMLElement>
  dataHook?: string
  skin?: 'dark' | 'light'
  priority?: ButtonPriority
  className?: string
}

const TYPES = {
  Button,
  TextButton,
}

export const BackButton: FC<BackButtonProps> = memo(
  ({ skin = 'dark', backButton, onClick, dataHook, type = 'TextButton', priority = 'primary', className }) => {
    const isLargeDesktopScreen = useMediaQuery(LARGE_DESKTOP)
    const Comp = TYPES[type]

    return (
      <Box position="absolute" margin="36px" zIndex="999" bottom={0} left={0} className={className}>
        <Comp
          priority={priority}
          skin={skin}
          size={isLargeDesktopScreen ? 'medium' : 'small'}
          prefixIcon={<ArrowLeft />}
          onClick={onClick}
          dataHook={dataHook}
        >
          {backButton}
        </Comp>
      </Box>
    )
  },
)
